/**
 * Analytics providers management.
 */

import { config } from '#~/config/config.js';
import type { AnalyticsProvider } from '../types/providers.js';
import { ConsoleProvider } from './console-provider.js';
import { GoogleAnalyticsProvider } from './ga-provider.js';
import { GoogleTagManagerProvider } from './gtm-provider.js';
import { PostHogProvider } from './posthog-provider.js';

// Cache for providers
let providers: AnalyticsProvider[] | null = null;

/**
 * Get all configured analytics providers.
 *
 * This function returns different providers based on the environment:
 * - In development: Console provider and PostHog
 * - In production: PostHog, Google Analytics, and Google Tag Manager
 */
export function getProviders(): AnalyticsProvider[] {
  if (providers) {
    return providers;
  }

  providers = [];

  // Always add console provider in non-production environments
  if (config.env !== 'prod') {
    providers.push(new ConsoleProvider());
  }

  providers.push(new PostHogProvider());

  // Add GA and GTM in production
  if (config.env === 'prod' || config.isProduction) {
    providers.push(new GoogleAnalyticsProvider());
    providers.push(new GoogleTagManagerProvider());
  }

  return providers;
}
